import { LANGUAGES, type LanguageCode, languageInfo } from "../types/language";

export type UiLocaleOption = {
  code: LanguageCode;
  name: string;
  flag: string;
};

export const UI_LOCALE_OPTIONS: UiLocaleOption[] = LANGUAGES.map(
  ({ code, nativeName, flag }) => ({ code, name: nativeName, flag }),
);

export function uiLocaleOption(
  code: string | null | undefined,
): UiLocaleOption | undefined {
  return UI_LOCALE_OPTIONS.find((locale) => locale.code === code);
}

export function uiLocaleLabel(code: LanguageCode): string {
  const { flag, nativeName } = languageInfo(code);
  return `${flag} ${nativeName}`;
}
